// extracted by mini-css-extract-plugin
module.exports =  {"title":"title__mJxlX","description":"description__P8xQ8"};